export default "__VITE_ASSET__UtZAdxcI__"